import { constants } from "./constants";
import { Notification } from "../../../api/api";
import actionCreatorFactory from "typescript-fsa";

const actionCreator = actionCreatorFactory("notifications");

export const notificationContentAction = actionCreator.async<
  void,
  Notification[]
>(constants.NotificationContent);

export const showNotificationDrawerAction = actionCreator(
  constants.ShowNotifcationDrawer
);
